import { BaseGridItem } from 'shared/types/desktop-grid'

import { wouldCollide } from './wouldCollide'

export const findFirstFreePosition = (
  items: BaseGridItem[],
  cols: number,
  rows: number,
  size: { width: number; height: number }
): { row: number; col: number } | null => {
  if (size.width > cols || size.height > rows) return null

  const maxRow = rows - size.height
  const maxCol = cols - size.width

  for (let row = 0; row <= maxRow; row++) {
    for (let col = 0; col <= maxCol; col++) {
      const collides = wouldCollide(
        crypto.randomUUID(),
        { row, col },
        { width: size.width, height: size.height },
        items
      )
      if (!collides) {
        return { row, col }
      }
    }
  }
  return null
}
